import React, { useState, useEffect } from 'react';
import AdminTemplate from 'components/templates/AdminTemplate';
import { Grid, Typography } from '@material-ui/core';
import useCategoriesIM from 'hooks/useCategoriesIM';
import ModalContainer from 'components/molecules/ModalContainer';
import IMCategoryForm from 'components/organisms/IMCategoryForm';
import IMCategoryDeleteModal from 'components/organisms/IMCategoryDeleteModal';
import IMCategoriesPromotionList from 'components/organisms/IMCategoriesPromotionList';
import { ICategoriesList, ICategoriesPromotion } from 'interfaces/imCategories.interface';

export default function IMCategoriesPromotion() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [categoryId, setCategoryId] = useState('');
  const [categoriesPromotion, setCategoriesPromotion] = useState<ICategoriesPromotion[]>([]);
  const { getCategories, addCategory, updateCategory } = useCategoriesIM();

  const getAllCategories = () => {
    setIsLoading(true);
    getCategories()
      .then((result: ICategoriesList) => {
        if (result !== undefined) {
          setCategoriesPromotion(result.categoriesPromotion);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleOnCloseModal = () => {
    setOpenModalEdit(false);
  };

  const saveCategory = (data: any) => {
    if (data.id) {
      return updateCategory(data);
    } else {
      return addCategory(data);
    }
  };

  const handleOnClickEditCategory = (warehouseId: string) => {
    setCategoryId(warehouseId);
    setOpenModalEdit(true);
  };

  const handleOnClickDeleteCategory = (warehouseId: string) => {
    setCategoryId(warehouseId);
    setOpenDeleteModal(true);
  };

  const addCategoryPromoButton = () => {
    setCategoryId('');
    setOpenModalEdit(true);
  };

  useEffect(() => {
    getAllCategories();
  }, []);

  return (
    <AdminTemplate>
      <Grid container justify="center" spacing={2}>
        <Grid item xs={12} sm={12}>
          <Typography variant="h5" component="h1" align="center">
            Gestión de Categorías Promoción
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={8}>
          <IMCategoriesPromotionList
            handleOnClickEditCategory={handleOnClickEditCategory}
            handleOnClickDeleteCategory={handleOnClickDeleteCategory}
            addCategoryPromoButton={addCategoryPromoButton}
            IMCategoriesPromotion={categoriesPromotion}
            isLoading={isLoading}
          />
        </Grid>
        <ModalContainer title="Crear categoría promoción" open={openModalEdit} onClose={handleOnCloseModal}>
          <IMCategoryForm
            handleCloseModal={handleOnCloseModal}
            handleOnSubmit={saveCategory}
            categoryId={categoryId}
            isPromotion={true}
            getAllCategories={getAllCategories}
          />
        </ModalContainer>
        <IMCategoryDeleteModal
          onClose={() => {
            setOpenDeleteModal(!openDeleteModal);
          }}
          open={openDeleteModal}
          categoryId={categoryId}
          getAllCategories={getAllCategories}
        />
      </Grid>
    </AdminTemplate>
  );
}
